import $ from 'jquery';

const lang = document.querySelector('.lang');

const toggleState = (el) => (state) => el.classList.toggle('opened', state);

$('.lang_button').on('click', () => {
  const isOpened = lang.classList.contains('opened');
  toggleState(lang)(!isOpened);
});

document.addEventListener('click', (e) => {
  if (e.target !== lang && !lang.contains(e.target)) toggleState(lang)(false);
});

$('.lang a').click(function () {
  const lang = $(this).data('lang');
  if (lang) localStorage.setItem('lang', lang);
});
